export default __webpack_public_path__ + "static/media/1179.fe899096.png";